export default function Hero() {
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const target = document.querySelector(href);
    if (target) {
      target.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="hero" className="relative min-h-[600px] md:min-h-[680px] flex items-center overflow-hidden">
      <div className="absolute inset-0 z-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20dynamic%20news%20media%20background%20with%20warm%20red%20and%20orange%20tones%2C%20flowing%20data%20streams%2C%20information%20network%20visualization%2C%20modern%20digital%20aesthetic%2C%20breaking%20news%20atmosphere%2C%20layered%20geometric%20patterns%20with%20soft%20gradients%2C%20editorial%20design%20style%2C%20dramatic%20lighting%20with%20warm%20highlights%2C%20professional%20newsroom%20feel&width=1800&height=1000&seq=hero-bg-51bl&orientation=landscape"
          alt="51爆料网 Hero 背景"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-black/55"></div>
      </div>

      <div className="section-container relative z-10 w-full py-16 md:py-20">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-primary-500/90 text-background-50 text-xs font-semibold mb-5 tracking-wide">
              <i className="ri-fire-line"></i>
              今日热爆
            </span>

            <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold font-heading text-background-50 leading-tight mb-4">
              51爆料网
              <br className="sm:hidden" />
              <span className="text-primary-300"> — 每日大赛爆料第一站</span>
            </h1>

            <p className="text-lg md:text-xl text-background-200 font-heading mb-6">
              聚焦赛事内幕 · 抢先吃瓜爆料
            </p>

            <p className="text-sm md:text-base text-background-300 leading-relaxed max-w-2xl mx-auto lg:mx-0 mb-8">
              51爆料网是国内领先的赛事爆料聚合平台，专注追踪每日大赛最新动态与内幕消息。我们汇集来自各大赛事的一手爆料、独家吃瓜内容和热门比赛深度解读，为你呈现最真实、最及时的赛事幕后故事。无论你是资深赛事迷还是吃瓜群众，这里都有你想要的精彩内容。平台每日更新，确保不错过任何一个热点事件。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 md:gap-8 mb-8">
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-accent-400 font-heading">100+</div>
                <div className="text-xs text-background-400 mt-1">每日更新爆料</div>
              </div>
              <div className="w-px h-10 bg-background-500/30 hidden sm:block"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-accent-400 font-heading">50+</div>
                <div className="text-xs text-background-400 mt-1">覆盖热门赛事</div>
              </div>
              <div className="w-px h-10 bg-background-500/30 hidden sm:block"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-accent-400 font-heading">10W+</div>
                <div className="text-xs text-background-400 mt-1">累计爆料内容</div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#updates"
                onClick={(e) => handleClick(e, '#updates')}
                className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 font-semibold rounded-md text-sm transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-flashlight-line"></i>
                立即浏览最新爆料
              </a>
              <a
                href="#topics"
                onClick={(e) => handleClick(e, '#topics')}
                className="inline-flex items-center gap-2 px-6 py-3 bg-background-50/15 hover:bg-background-50/25 text-background-50 font-medium rounded-md text-sm border border-background-50/30 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-discuss-line"></i>
                参与话题讨论
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-[500px] lg:max-w-none">
            <div className="relative rounded-lg overflow-hidden bg-background-900/40 backdrop-blur-sm border border-background-50/10">
              <img
                src="https://readdy.ai/api/search-image?query=Vibrant%20editorial%20collage%20of%20sports%20competition%20highlights%2C%20breaking%20news%20visuals%2C%20dynamic%20event%20photography%20style%2C%20warm%20dramatic%20tones%2C%20layered%20composition%20with%20headlines%20and%20action%20shots%2C%20modern%20magazine%20layout%20aesthetic%2C%20rich%20contrast%20with%20dark%20and%20bright%20accents%2C%20professional%20news%20media%20style%2C%20editorial%20design%20with%20bold%20typography%20feel&width=800&height=600&seq=hero-visual-51bl&orientation=landscape"
                alt="51爆料网 赛事爆料主题视觉"
                className="w-full h-auto object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}